import { apiCall } from "./apiAction";
import * as cartSettingsActionTypes from "../types/cartSettingsActionType";

export const fetchCartSettings = () => (dispatch, getState) => {
	const data = {};
	const uri = "api/v2ShoppingCart/GetSettings";

	dispatch(
		apiCall(
			uri,
			data,
			undefined,
			{
				method: "GET",
				credentials: "omit"
			},
			{
				request: {
					type: cartSettingsActionTypes.FETCH_SETTINGS_REQUEST
				},
				success: {
					type: cartSettingsActionTypes.FETCH_SETTINGS_SUCCESS
				},
				failure: {
					type: cartSettingsActionTypes.FETCH_SETTINGS_FAILURE
				}
			}
		)
	);
};
